import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1506Component } from './kymw1506.component';
import { RegistCwsIconData } from './api-services/regist-cws-icon-data-service';

/**
 * アイコン登録画面 モジュール設定クラス
 *
 * @export KYMW1506Module
 * @class KYMW1506Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1506Component,
  ],
  providers: [
    RegistCwsIconData,
  ],
})
export class KYMW1506Module {
}
